import { WebshopProduct } from '@cldsystems/ws-api-client';
import { FC } from 'react';
import { Table, TableBody, TableCell, TableColumn, TableHeader, TableRow } from '@/components/ui';
import { ArrayElement } from '@/types/common';

type AttributeGroup = ArrayElement<
  WebshopProduct['categoryAttributeGroups' | 'productAttributeGroups']
>;

type AttributeOption = ArrayElement<AttributeGroup['options']>;

const formatOptionValues = (option: AttributeOption) =>
  'values' in option ? option.values.join(', ') : option.value;

type Props = {
  attributeGroup: AttributeGroup;
};

const AttributeGroupTable: FC<Props> = ({ attributeGroup }) => {
  return (
    <>
      <h2 className="mb-2 text-lg font-medium">{attributeGroup.name}</h2>
      <Table
        hideHeader
        isStriped
        classNames={{ wrapper: 'shadow-none p-0 border border-default-300 rounded-lg' }}
      >
        <TableHeader>
          <TableColumn>key</TableColumn>
          <TableColumn>values</TableColumn>
        </TableHeader>
        <TableBody>
          {attributeGroup.options.map(option => (
            <TableRow key={option.id} className="grid grid-cols-2">
              <TableCell className="col-span-1">{option.key}</TableCell>
              <TableCell className="col-span-1">{formatOptionValues(option)}</TableCell>
            </TableRow>
          ))}
        </TableBody>
      </Table>
    </>
  );
};

export default AttributeGroupTable;
